import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

/**
 * Kind chip — CMP KindChip parity: kind "text" -> blue badge, anything else (e.g. "effect") ->
 * amber/warning badge.
 */
export function KindBadge({ kind }: { kind: string }) {
  const isText = kind.trim().toLowerCase() === 'text';
  return (
    <Badge
      variant="outline"
      className={cn(
        'border-transparent font-medium',
        isText ? 'bg-blue-400/15 text-blue-400' : 'bg-amber-400/15 text-amber-400',
      )}
    >
      {kind.trim() || '?'}
    </Badge>
  );
}
